export default {
  brand: 'Corendon',
  brandTagline: 'Müşteri Hizmetleri',
  heroTitle: 'Corendon Müşteri Hizmetlerine Hoş Geldiniz',
  heroSubtitle: 'Uçuşunuz, değişiklik veya onay için dijital asistanımızla konuşun.',
  startButton: 'Sohbete başla',
  endButton: 'Sohbeti bitir',
  loading: 'Bağlanıyor…',
  micHint: 'Tarayıcınız mikrofon izni isteyecektir.',
  micPermissionTitle: 'Mikrofon izni gerekli',
  micPermissionBody: 'Asistanla konuşabilmek için lütfen mikrofon iznini verin.',
  helpListTitle: 'Size yardımcı olabileceğimiz konular:',
  helpItem1: 'Uçuş durumu ve gecikmeler',
  helpItem2: 'Rezervasyon değişikliği veya yeniden rezervasyon',
  helpItem3: 'E-posta ile onay',
  pausedTitle: 'Sohbet duraklatıldı',
  pausedBody: 'Mobil tarayıcılar arka planda sesi sürdüremez. Devam etmek için bu sekmeye geri dönün.',
  resumed: 'Tekrar hoş geldiniz — kaldığımız yerden devam ediyoruz.',
  installPwaIos: 'En iyi deneyim için: paylaş simgesine dokunup "Ana Ekrana Ekle"yi seçin.',
  installPwaAndroid: 'En iyi deneyim için Corendon uygulamasını yükleyin.',
  installPwaButton: 'Yükle',
  installPwaDismiss: 'Şimdi değil',
  footerDemo: 'Demo ortamı — bu servis kurgusal rezervasyon verileri kullanır.',
  errorGeneric: 'Bir şeyler ters gitti. Lütfen tekrar deneyin.',
  errorAuthRequired: 'Asistanı kullanmak için oturum açmanız gerekiyor.',
  loginButton: 'Google ile giriş yap',
}
